const QUICK_ADD_ML = 250;

export default function WaterCounter({
  waterMl,
  onChange,
}: {
  waterMl: number;
  onChange: (ml: number) => void;
}) {
  return (
    <div className="mt-4 flex items-center justify-between rounded-card border border-line bg-white px-4 py-3">
      <div>
        <p className="text-sm font-medium text-ink">Water</p>
        <p className="text-xs text-forest-500">{(waterMl / 1000).toFixed(2)} L today</p>
      </div>
      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={() => onChange(Math.max(0, waterMl - QUICK_ADD_ML))}
          aria-label="Remove a glass of water"
          className="flex h-tap w-tap items-center justify-center rounded-full border border-line text-lg text-forest-700"
        >
          −
        </button>
        <button
          type="button"
          onClick={() => onChange(waterMl + QUICK_ADD_ML)}
          aria-label="Add a glass of water"
          className="flex h-tap w-tap items-center justify-center rounded-full bg-forest-700 text-lg text-canvas"
        >
          +
        </button>
      </div>
    </div>
  );
}
